module.exports = __webpack_public_path__ + "assets/media/auth.88b59e9a.mp3";